module.exports = __webpack_public_path__ + "img/audio-bg-fill.cc6323ab.png";